// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SetMembership__wrapper__3I7iS","finish":"SetMembership__finish__ed24D","submit":"SetMembership__submit__j8OKb"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/dashboard/user/SetMembership/SetMembership.scss
// module id = 307
// module chunks = 0